<script setup>
  import { computed, ref, watch, inject } from 'vue'
  import { ArrowAltCircleUpRegular, ArrowAltCircleLeftRegular } from '@vicons/fa'
  import { NIcon, NPopover, NSwitch, NH4 } from 'naive-ui'

  const appStoreFn = inject('appStoreFn')
  const appStore = appStoreFn()
  const navTitle = computed(
    () => `Navigation appears on ${appStore.navStyle === 'left' ? 'Left' : 'Top'} of the screen`
  )
  const topNavModel = ref(appStore.navStyle === 'top')
  const isLeftNav = computed(() => appStore.navStyle === 'left')
  const isTopNav = computed(() => appStore.navStyle === 'top')
  watch(topNavModel, (nav) => appStore.updateNavStyle(nav ? 'top' : 'left'))
</script>
<template>
  <NPopover trigger="hover">
    <template #trigger>
      <NIcon :title="navTitle">
        <ArrowAltCircleUpRegular v-if="isTopNav" />
        <ArrowAltCircleLeftRegular v-if="isLeftNav" />
      </NIcon>
    </template>
    <span class="flex-inline">
      <NH4>Navigation Position</NH4>
      <NSwitch
        v-model:value="topNavModel"
        :title="navTitle"
        :disabled="!appStore.allowNavStyleUpdate"
        size="large"
      >
        <template #unchecked-icon>
          <NIcon :component="ArrowAltCircleLeftRegular" />
        </template>
        <template #checked-icon>
          <NIcon :component="ArrowAltCircleUpRegular" />
        </template>
      </NSwitch>
      <span class="ml-10 capitalize">{{ appStore.navStyle }}</span>
    </span>
  </NPopover>
</template>
